import {Injectable} from '@angular/core';
import * as countries from 'i18n-iso-countries';
import * as de from 'i18n-iso-countries/langs/de.json';
import * as en from 'i18n-iso-countries/langs/en.json';
import * as es from 'i18n-iso-countries/langs/es.json';
import * as hr from 'i18n-iso-countries/langs/hr.json';
import * as it from 'i18n-iso-countries/langs/it.json';
import * as ja from 'i18n-iso-countries/langs/ja.json';
import * as pl from 'i18n-iso-countries/langs/pl.json';
import * as pt from 'i18n-iso-countries/langs/pt.json';
import * as ru from 'i18n-iso-countries/langs/ru.json';
import * as uk from 'i18n-iso-countries/langs/uk.json';
import {TranslateService} from "@ngx-translate/core";
import {BehaviorSubject} from "rxjs";

countries.registerLocale(de);
countries.registerLocale(en);
countries.registerLocale(es);
countries.registerLocale(hr);
countries.registerLocale(it);
countries.registerLocale(ja);
countries.registerLocale(pl);
countries.registerLocale(pt);
countries.registerLocale(ru);
countries.registerLocale(uk);

const COMMON_COUNTRIES = ['PL', 'IT', 'ES', 'GB', 'DE', 'BR'];

export class CountryOption {
  constructor(code: string, name: string, localizedName: string) {
    this.code = code;
    this.name = name;
    this.localizedName = localizedName;
  }

  code: string;
  name: string;
  localizedName: string;
}

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private countriesSource = new BehaviorSubject<CountryOption[]>(null);
  private countriesSource$ = this.countriesSource.asObservable();

  constructor(private translateService: TranslateService) {
    if(this.translateService.currentLang)
      this.prepareCountries()
    this.translateService.onLangChange.subscribe(_ =>
      this.prepareCountries()
    )
  }

  getCountries() {
    return this.countriesSource$
  }

  private prepareCountries() {
    let defaultLang = this.translateService.defaultLang
    let lang = this.translateService.currentLang
    const allCountries = countries.getNames(defaultLang, {select: 'official'});
    const allCountriesLocalized = countries.getNames(lang, {select: 'official'});

    const common = COMMON_COUNTRIES.map(code =>
      new CountryOption(code, allCountries[code], allCountriesLocalized[code]));

    const others = Object.entries(allCountries)
      .filter(([code]) => !COMMON_COUNTRIES.includes(code))
      .map(([code, name]) => new CountryOption(code, name, allCountriesLocalized[code]))
      .sort((a, b) => a.localizedName.localeCompare(b.localizedName, lang));
    this.countriesSource.next([...common, ...others]);
  }
}
